
import { ref, defineComponent, onMounted, computed } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as Yup from "yup";
import Avatar from "vue-avatar-component";
import FeedsWidget3 from "@/components/widgets/feeds/Widget3.vue";

import { rutEsValido, formatRut, yupIsRut } from "@/core/validators/YupRut";

interface ProveedorDetails {
  nombreProveedor: string;
  rutProveedor: string;
}

interface ProfileDetails {
  ticketId: string;
  fechaTicket: Date;
  rutProveedor: string;
  contactoEmail: string;
  contactoNombre: string;
  contactoTelefono: number;
  tipo: string;
  respondido: boolean;
  leido: boolean;
  comentario: string;
  respuesta: string;
  fechaRespuesta: Date;
  usuarioRespuesta: string;
  ticketReferencia: string;
}

export default defineComponent({
  name: "profile-settings",
  components: {
    ErrorMessage,
    Field,
    Form,
    Avatar,
    FeedsWidget3,
  },
  setup() {
    const submitButton1 = ref<HTMLElement | null>(null);
    const submitButton2 = ref<HTMLElement | null>(null);
    const submitButton3 = ref<HTMLElement | null>(null);
    const submitButton4 = ref<HTMLElement | null>(null);
    const submitButton5 = ref<HTMLElement | null>(null);
    const updateEmailButton = ref<HTMLElement | null>(null);
    const updatePasswordButton = ref<HTMLElement | null>(null);
    const route = useRoute();
    const router = useRouter();
    const id = route.params.id;
    const emailFormDisplay = ref(false);
    const passwordFormDisplay = ref(false);

    const profileDetailsValidator = Yup.object().shape({
      respuesta: Yup.string().required("Es obligatorio").label("Respuesta"),
    });

    const saveChanges1 = () => {
      if (submitButton1.value) {
        store
          .dispatch(Actions.UPD_RESP_TICKET, profileDetails.value)
          .then(() => {
            loading = ref(false);
            Swal.fire({
              text: "Su respuesta ha sido enviada correctamente al proveedor.",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              router.push({ name: "apps-tickets-listing" });
            });
          })
          .catch(() => {
            const [error] = Object.keys(store.getters.getTicketErrors);
            Swal.fire({
              text: store.getters.getTicketErrors[error],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Intenar nuevamente!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });
      }
    };

    const store = useStore();

    onMounted(() => {
      setCurrentPageBreadcrumbs("Modificar Datos", ["Páginas", "Dashboard"]);
      store
        .dispatch(Actions.GET_TICKET, id)
        .then(() => {
          loading = ref(false);
          profileDetails.value = store.getters.currentTicket;
          store
            .dispatch(
              Actions.GET_PROVEEDOR_RUT,
              store.getters.currentTicket.rutProveedor
            )
            .then(() => {
              loading = ref(false);
              currentProveedor.value = store.getters.currentProveedor;
            })
            .catch(() => {
              const [error] = Object.keys(store.getters.getProveedorErrors);
            });
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getTicketErrors);
        });
    });

    const currentProveedor = ref<ProveedorDetails>({
      nombreProveedor: store.getters.currentProveedor.nombreProveedor,
      rutProveedor: store.getters.currentProveedor.rutProveedor,
    });
    const profileDetails = ref<ProfileDetails>({
      ticketId: store.getters.currentTicket.ticketId,
      fechaTicket: store.getters.currentTicket.fechaTicket,
      rutProveedor: store.getters.currentTicket.rutProveedor,
      contactoEmail: store.getters.currentTicket.contactoEmail,
      contactoNombre: store.getters.currentTicket.contactoNombre,
      contactoTelefono: store.getters.currentTicket.contactoTelefono,
      tipo: store.getters.currentTicket.tipo,
      respondido: store.getters.currentTicket.respondido,
      leido: store.getters.currentTicket.leido,
      comentario: store.getters.currentTicket.comentario,
      respuesta: store.getters.currentTicket.fechaRespuesta,
      fechaRespuesta: store.getters.currentTicket.fechaRespuesta,
      usuarioRespuesta: store.getters.currentTicket.usuarioRespuesta,
      ticketReferencia: store.getters.currentTicket.ticketReferencia,
    });
    let loading = ref(true);
    return {
      submitButton1,
      submitButton2,
      submitButton3,
      submitButton4,
      submitButton5,
      saveChanges1,
      profileDetails,
      emailFormDisplay,
      passwordFormDisplay,
      profileDetailsValidator,
      updateEmailButton,
      updatePasswordButton,
      currentProveedor,
    };
  },
});
